import { QuestionTitle } from "components/atoms"
import { Screen } from "config/types"
import { FormattedMessage, useIntl } from "react-intl"
import { twMerge } from "tailwind-merge"
import lockIcon from "assets/images/icon-lock.svg"
import { PrimaryButton } from "components/molecules"
import React, { ChangeEvent, useState } from "react"

type EmailInputScreenProps = {
  screen: Screen
  onClick: () => void
}

const PRIVACY_HREF = "https://pure.app/content/en/privacy"

function isValidEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(email)
}

export function EmailInputScreen(props: EmailInputScreenProps) {
  const { formatMessage } = useIntl()
  const [email, setEmail] = useState("")
  const [error, setError] = useState(false)

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (error) {
      setError(false)
    }

    setEmail(e.target.value)
  }

  const onContinueClick = () => {
    if (!isValidEmail(email)) {
      setError(true)
      return
    }

    localStorage.setItem("user_email", email)
    props.onClick()
  }

  return (
    <div className="flex flex-col justify-between h-full">
      <div>
        <QuestionTitle id="email_input.title" />
        <div className="relative">
          {error && (
            <div className="text-[#DD4C28] text-xs absolute top-0 left-0">
              <FormattedMessage id="email_input.error" />
            </div>
          )}
          <input
            type="email"
            autoFocus
            maxLength={254}
            value={email}
            onChange={onChange}
            placeholder={formatMessage({ id: "email_input.placeholder" })}
            className={twMerge(
              "py-[11px] px-4 border border-gray-250 rounded-lg text-lg text-white placeholder:text-gray-250 bg-transparent outline-none",
              "mt-6 mb-3 w-full",
              error &&
                "text-[#DD4C28] border-[#DD4C28] placeholder:text-[#DD4C28]",
            )}
          />
        </div>
        <div className="flex items-start">
          <img src={lockIcon} width="20" height="20" className="mr-2 mt-1" />
          <div className="text-xs">
            <FormattedMessage
              id="email_input.hint"
              values={{
                link: (
                  <a
                    target="_blank"
                    href={PRIVACY_HREF}
                    className="border-b border-dotted border-white"
                  >
                    <FormattedMessage id="email_input.link" />
                  </a>
                ),
              }}
            />
          </div>
        </div>
      </div>

      <div className="w-full text-center pb-4">
        <PrimaryButton theme="darkgray" onClick={onContinueClick}>
          <FormattedMessage id="continue" />
        </PrimaryButton>
      </div>
    </div>
  )
}
